﻿
export const initialiseAnalytics = () => {
    if (window.analyticsKey) {
        !function () {
            var analytics = window.analytics = window.analytics || []; if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
                analytics.invoked = !0; analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"]; analytics.factory = function (e) { return function () { var t = Array.prototype.slice.call(arguments); t.unshift(e); analytics.push(t); return analytics } }; for (var e = 0; e < analytics.methods.length; e++) { var t = analytics.methods[e]; analytics[t] = analytics.factory(t) } analytics.load = function (e, t) { var n = document.createElement("script"); n.type = "text/javascript"; n.async = !0; n.src = "https://cdn.segment.com/analytics.js/v1/" + e + "/analytics.min.js"; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(n, a); analytics._loadOptions = t }; analytics.SNIPPET_VERSION = "4.1.0";
                analytics.load(window.analyticsKey);
                analytics.page();
            }
        }();
    }
}

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(`;`).shift();
    else return false;
}

// fetches google id by ga or cookie
export const getGoogleID = () => {
    let googleID = null;
    if (
        typeof window.ga === `function` &&
        typeof window.ga.getAll === `function`
    )
        googleID = window.ga.getAll()[0].get(`clientId`);
    else if (getCookie(`_ga`)) {
        let str = getCookie(`_ga`);
        str = str.slice(6);
        googleID = str;
    }
    return googleID;
}


export const trackSubmit = (classActionName) => {
    if (typeof window !== 'undefined' && typeof window.analytics === 'object') {
        const properties = {
            category: 'Form',
            label: classActionName
        };
        const gaid = getGoogleID();
        // if google id adds ga id to tracks
        if (gaid) properties.gaid = gaid;
        window.analytics.track('Class Action Form Submitted', properties);
    }
}

export const anonymousId = () => {
    if (typeof window !== "undefined" && window.analytics && window.analytics.user) {
        return window.analytics.user().anonymousId();
    } else {
        return null;
    }
}
